module.exports = __webpack_public_path__ + "img/jump.e838d363.svg";